import * as FeatherIcons from 'vue-feather-icons';

export default {
    items: [
        {
            name: 'Dashboard',
            type: 'dashboard',
            route: 'dashboard',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.GridIcon,
        },
        {
            name: 'Pages',
            route: 'pages',
            type: 'page',
            // children: [
            //     // { name: 'Layouts', route: 'layouts' },
            //     { name: 'Pages', route: 'pages', type: 'page' },
            //     { name: 'Panel library', route: 'panels', type: 'panel' },
            // ],
            // iconName: '',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.LayersIcon,
        },
        {
            name: 'Notifications',
            route: 'notifications',
            type: 'notification',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.BellIcon,
        },
        {
            name: 'Assets',
            route: 'assets/0',
            type: 'asset',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.ImageIcon,
        },
        {
            name: 'Products',
            route: 'products',
            type: 'product',
            color: 'navy',
            group: 'Catalogue',
            iconComponent: FeatherIcons.PackageIcon,
        },
        {
            name: 'Categories',
            route: 'categories',
            type: 'category',
            color: 'navy',
            group: 'Catalogue',
            iconComponent: FeatherIcons.TagIcon,
        },
        {
            name: 'BC Categories',
            route: 'nav_categories',
            type: 'nav_category',
            color: 'navy',
            group: 'Catalogue',
            iconComponent: FeatherIcons.DatabaseIcon,
        },
        {
            name: 'Promotions',
            route: 'promotions',
            type: 'promotion',
            color: 'navy',
            group: 'Catalogue',
            iconComponent: FeatherIcons.DollarSignIcon,
        },
        {
            name: 'Customers',
            ...{ name: 'Customers', route: 'customers', type: 'customer' },
            color: 'navy',
            group: 'customers',
            iconComponent: FeatherIcons.UsersIcon,
        },
        {
            name: 'Logins',
            route: 'customer_logins',
            type: 'customer_login',
            color: 'navy',
            group: 'customers',
            iconComponent: FeatherIcons.KeyIcon,
        },
        {
            name: 'Enquiries',
            route: 'enquiries',
            type: 'enquiry',
            color: 'navy',
            group: 'customers',
            iconComponent: FeatherIcons.MessageSquareIcon,
        },
        {
            name: 'Orders',
            route: 'orders',
            type: 'order',
            children: [
                { name: 'Orders', route: 'orders', type: 'order' },
                { name: 'Order Status Templates', route: 'order_emails', type: 'order_email' },
            ],
            color: 'navy',
            group: 'client',
            iconComponent: FeatherIcons.FileTextIcon,
        },
        {
            name: 'Accounts',
            children: [
                { name: 'Users', route: 'users' },
                { name: 'Roles', route: 'roles' },
            ],
            // iconName: '',
            color: 'navy',
            group: 'settings',
            iconComponent: FeatherIcons.LockIcon,
        },
        {
            name: 'Settings',
            children: [
                { name: 'Settings', route: 'settings', type: 'setting' },
                { name: 'Redirect URLs', route: 'redirect_urls', type: 'redirect_url' },
                { name: 'Freight Matrix', route: 'freights', type: 'freight' },
            ],
            // iconName: '',
            color: 'navy',
            group: 'settings',
            iconComponent: FeatherIcons.SettingsIcon,
        }
    ],
    defaultItem: 'Content',
}
